import { useTheme } from '../theme/ThemeProvider.js';

/**
 * 야간/주간 모드 토글. 지금 모드를 아이콘 + 글자로 같이 보여준다 - 아이콘만으로는
 * "지금 무슨 모드인지" 헷갈릴 수 있어서다. Layout 상단바에 항상 떠 있어 어느
 * 화면에서든 바로 바꿀 수 있다(ThemeProvider 가 <html data-theme> 를 바꾸므로
 * 전체 페이지에 즉시 적용된다).
 */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const nextLabel = isDark ? '라이트 모드로 전환' : '다크 모드로 전환';

  return (
    <button
      type="button"
      className="btn btn--ghost btn--sm theme-toggle"
      onClick={toggleTheme}
      aria-label={nextLabel}
      title={nextLabel}
    >
      {isDark ? (
        <svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" fill="currentColor">
          <path d="M10 2.5a.9.9 0 0 1 .87.68 6.7 6.7 0 0 0 5.95 5.95.9.9 0 0 1 0 1.74 6.7 6.7 0 0 0-5.95 5.95.9.9 0 0 1-1.74 0 6.7 6.7 0 0 0-5.95-5.95.9.9 0 0 1 0-1.74 6.7 6.7 0 0 0 5.95-5.95A.9.9 0 0 1 10 2.5Z" />
        </svg>
      ) : (
        <svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" fill="currentColor">
          <circle cx="10" cy="10" r="4" />
          <path
            strokeLinecap="round"
            stroke="currentColor"
            strokeWidth="1.6"
            d="M10 1.8v2M10 16.2v2M18.2 10h-2M3.8 10h-2M15.6 4.4l-1.4 1.4M5.8 14.2l-1.4 1.4M15.6 15.6l-1.4-1.4M5.8 5.8 4.4 4.4"
          />
        </svg>
      )}
      <span>{isDark ? '다크' : '라이트'}</span>
    </button>
  );
}
